import { useRef, useState, useEffect } from "react";
import { Camera, RefreshCw, Check } from "lucide-react";
import { Button } from "@/components/ui/button";

export function SelfieCapture({ value, onChange }) {
  const videoRef = useRef(null);
  const streamRef = useRef(null);
  const [active, setActive] = useState(false);
  const [err, setErr] = useState("");

  const stop = () => {
    if (streamRef.current) {
      streamRef.current.getTracks().forEach((t) => t.stop());
      streamRef.current = null;
    }
    setActive(false);
  };

  useEffect(() => () => stop(), []);

  const start = async () => {
    setErr("");
    try {
      const s = await navigator.mediaDevices.getUserMedia({ video: { facingMode: "user" } });
      streamRef.current = s;
      setActive(true);
      setTimeout(() => {
        if (videoRef.current) { videoRef.current.srcObject = s; videoRef.current.play().catch(() => {}); }
      }, 60);
    } catch {
      setErr("Kamera tidak tersedia atau izin ditolak. Absensi tetap bisa dilanjutkan.");
    }
  };

  const capture = () => {
    const v = videoRef.current;
    if (!v) return;
    const canvas = document.createElement("canvas");
    canvas.width = 320; canvas.height = 240;
    canvas.getContext("2d").drawImage(v, 0, 0, 320, 240);
    onChange(canvas.toDataURL("image/jpeg", 0.6));
    stop();
  };

  return (
    <div className="rounded-2xl bg-slate-950/40 p-4" data-testid="selfie-capture">
      <p className="mb-2 flex items-center gap-1.5 text-sm font-medium text-slate-300">
        <Camera className="h-4 w-4 text-sky-400" /> Selfie Verifikasi <span className="text-[11px] text-slate-500">(opsional)</span>
      </p>
      {value ? (
        <div className="flex items-center gap-3">
          <img src={value} alt="selfie" className="h-20 w-28 rounded-lg object-cover" />
          <Button type="button" size="sm" variant="ghost" data-testid="selfie-retake-button"
            className="text-slate-300 hover:bg-slate-800 hover:text-white"
            onClick={() => { onChange(null); start(); }}>
            <RefreshCw className="mr-1 h-4 w-4" /> Ulangi
          </Button>
        </div>
      ) : active ? (
        <div className="space-y-2">
          <video ref={videoRef} className="h-40 w-full rounded-lg bg-black object-cover" muted playsInline />
          <Button type="button" size="sm" data-testid="selfie-capture-button"
            className="w-full bg-sky-500 hover:bg-sky-600" onClick={capture}>
            <Check className="mr-1 h-4 w-4" /> Ambil Foto
          </Button>
        </div>
      ) : (
        <Button type="button" size="sm" variant="outline" data-testid="selfie-start-button"
          className="w-full border-slate-700 bg-slate-800 text-slate-200 hover:bg-slate-700" onClick={start}>
          <Camera className="mr-1 h-4 w-4" /> Nyalakan Kamera
        </Button>
      )}
      {err && <p className="mt-2 text-xs text-amber-400">{err}</p>}
    </div>
  );
}
